import { render, staticRenderFns } from "./StudentLoan.vue?vue&type=template&id=1a3bde2a&scoped=true&"
import script from "./StudentLoan.vue?vue&type=script&lang=js&"
export * from "./StudentLoan.vue?vue&type=script&lang=js&"
import style0 from "./StudentLoan.vue?vue&type=style&index=0&id=1a3bde2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3bde2a",
  null
  
)

export default component.exports